import {createBrowserRouter, Navigate, RouterProvider} from 'react-router-dom'
import OnboardingPage from './components/OnboardingPage'

const onboardingRouter = createBrowserRouter(
    [
        {
            path: '/onboarding',
            element: <OnboardingPage />,
        },
        {
            path: '*',
            element: <Navigate to="/onboarding" />,
        },
    ],
    {basename: '/portal'},
)

const OnboardingRouter = () => {
    return <RouterProvider router={onboardingRouter} />
}

export default OnboardingRouter
